import { HorizontalOriginOption, Tooltip, VerticalOriginOption } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';
import { interpolateString } from '~common/utilities/StringInterpolation';
import { HelpService } from '~commonInfra/services/HelpService';
import { TooltipAnchor } from '~src/app/spaces/Tooltips/TooltipAnchor';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { bridgeTooltipClass, poolTableHeadersLine } from '../BridgeMultiPoolSection/BridgeMultiPoolTableHeaders';
import {  DEFAULT_TEST_ID, EMPTY_TEST_ID, UNASSIGNED_TEST_ID } from './BridgeRemoteAgentsSectionBody';

export type BridgeRemoteAgentsSectionHeadersProps = Readonly<{
  isDefaultPool: boolean;
}>

export function BridgeRemoteAgentsSectionHeaders(props: BridgeRemoteAgentsSectionHeadersProps) {
  const tooltipPath = imgPath('info_normal.svg');
  let poolTestId = EMPTY_TEST_ID;
  let rowClass = 'tb-data-grid-headers-line';
  if (FeatureFlags.edgeMultiPoolEnabled) {
    poolTestId = props.isDefaultPool ? DEFAULT_TEST_ID : UNASSIGNED_TEST_ID;
    rowClass = poolTableHeadersLine;
  }

  return <>
    <tbody>
      <tr>
        <th className={rowClass}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-computer-name-column-header' + poolTestId}>
            {Messages.siteRemoteAgentComputerNameColumnName()}
          </span>
        </th>
        <th className={rowClass}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-owner-column-header' + poolTestId}>
            {Messages.siteRemoteAgentOwnerColumnName()}
          </span>
        </th>
        {!FeatureFlags.edgeMultiPoolEnabled &&
          <th className={rowClass}>
            <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-name-column-header'}>
              {Messages.siteRemoteAgentPoolColumnName()}
              {GetPoolNameTooltip(tooltipPath)}
            </span>
          </th>
        }
        <th className={rowClass} key={0}>
          <div className={'tb-data-grid-header-text'} data-tb-test-id={'agent-version-column-header' + poolTestId}>
            {GetAgentVersionTooltip(tooltipPath)}
          </div>
        </th>
        <th className={rowClass}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-status-column-header' + poolTestId}>
            {Messages.siteRemoteAgentStatusColumnName()}
            {GetAgentStatusTooltip(tooltipPath)}
          </span>
        </th>
        <th className={rowClass}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'agent-last-connected-column-header' + poolTestId}>
            {Messages.siteRemoteAgentLastConnectedColumnName()}
          </span>
        </th>
        <th className={rowClass} data-tb-test-id={'agent-actions-column-header' + poolTestId} />
      </tr>
    </tbody>
  </>;
}

const clientUpdateHelpText = () => {
  const url = HelpService.getServerHelpUrlByCategory('bridge-release');
  const replacements = {
    TABLEAU_BRIDGE_RELEASES: () => <a href={url}>{Messages.remoteAgentVersionBridgeReleases()}</a>
  };
  return interpolateString(Messages.remoteAgentVersionPopoverDetail_new(), replacements);
};

function GetPoolNameTooltip(tooltipPath: string) {
  return (
    <Tooltip testId={'agent-pool-tooltip'} getContent={() => { return <span>{Messages.siteRemoteAgentPoolNamePopoverDetail()}</span>; }}>
      <img className={bridgeTooltipClass} src={tooltipPath} alt={''} />
    </Tooltip>
  );
}

function GetAgentVersionTooltip(tooltipPath: string) {
  return (
    <TooltipAnchor
      key={0}
      tooltipContent={() => { return <div>{clientUpdateHelpText()}</div>; }}
      width={200}
      title={Messages.siteRemoteAgentVersionColumnName()}
      disableAutoFocus={true}
      anchorOrigin={{
        horizontal: HorizontalOriginOption.centerX,
        vertical: VerticalOriginOption.top
      }}>
      {Messages.siteRemoteAgentVersionColumnName()}
      <img className={bridgeTooltipClass} src={tooltipPath} alt={''} />
    </TooltipAnchor>
  );
}

function GetAgentStatusTooltip(tooltipPath: string) {
  return (
    <Tooltip getContent={() => { return <span>{Messages.remoteAgentStatusPopoverDetail()}</span>; }}>
      <img className={bridgeTooltipClass} src={tooltipPath} alt={''} />
    </Tooltip>
  );
}
